const ON_DEMAND_CANONICAL_ID = 'on-demand';
const GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID = 'global-data-editing-tool';

const CANONICAL_PRODUCT_IDS: Record<string, string> = {
  'on-demand': ON_DEMAND_CANONICAL_ID,
  'on-demand-portal': ON_DEMAND_CANONICAL_ID,
  on_demand: ON_DEMAND_CANONICAL_ID,
  on_demand_portal: ON_DEMAND_CANONICAL_ID,
  ondemandportal: ON_DEMAND_CANONICAL_ID, // camelCase variant, e.g. product_id "onDemandPortal"
  'global-data-editing-tool': GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID,
  'global-data-editing': GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID,
  global_data_editing_tool: GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID,
  global_data_editing: GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID,
  globaldataeditingtool: GLOBAL_DATA_EDITING_TOOL_CANONICAL_ID,
};

export function normalizeEmbeddedProductId(productId: string): string {
  const trimmed = productId.trim();

  if (!trimmed) {
    return trimmed;
  }

  const normalizedKey = trimmed.toLowerCase().replace(/_/g, '-');
  return CANONICAL_PRODUCT_IDS[normalizedKey] ?? trimmed;
}

export function isSameEmbeddedProduct(
  leftProductId: string,
  rightProductId: string,
): boolean {
  return (
    normalizeEmbeddedProductId(leftProductId) ===
    normalizeEmbeddedProductId(rightProductId)
  );
}
